const INIT_STATE = {
   defaultData: [],
   technames: {},
   gridId: "",
   projectList: [],
   clientId: {},
   formTabs: null,
   currentTabKey: 0,
   gridRequired: {},
   emailFieldError: false,
   currentTechnamesValues: [],
   gridDefaultValues: []
};

export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_EMAIL_FIELD_ERROR": {
         return {
            ...state,
            emailFieldError: action.value
         };
      }
      case "SET_GRID_REQUIRED": {
         return {
            ...state,
            gridRequired: Object.assign(state.gridRequired, action.obj)
         };
      }
      case "SAVE_DEFAULT_DATA": {
         return { ...state, defaultData: action.payload };
      }
      case "SAVE_TECHNAMES": {
         return { ...state, technames: action.payload };
      }
      case "SET_GRID_FORM_ID": {
         return { ...state, gridId: action.payload };
      }
      case "SET_CLIENT_PROJECT_LIST": {
         return { ...state, projectList: action.data };
      }
      case "SET_CLIENT_ID": {
         return { ...state, clientId: action.obj };
      }
      case "SET_CURRENT_TAB": {
         return { ...state, currentTabKey: action.payload };
      }
      case "SET_FORM_TABS":
         return {
            ...state,
            currentTabKey: 0,
            formTabs: action.payload
         };
      case "SET_CURRENT_TECHNAMES_VALUES":
         return {
            ...state,
            currentTechnamesValues: action.payload
         };
      case "SET_GRID_DEFAULT_VALUES":
         return {
            ...state,
            gridDefaultValues: action.payload
         };
      default:
         return state;
   }
};
